export default __webpack_public_path__ + "static/media/juice-fruit-r-mobile@3x.15505bc1.png";